//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gql } from 'graphql-tag'

const UPDATE_MANY_USER_LEVELS = gql`
  mutation ($data: UpdateManyUserLevelsInput) {
    updateManyUserLevels(data: $data) {
      id
      userId
      levelId
    }
  }
`

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    levelIds: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      isSubscribed: [],
      isSubscribedStartState: []
    }
  },
  computed: {
    account() {
      return this.$store.get('user/user') || null
    }
  },
  mounted() {
    if (this.account) {
      const userLevels = this.account.userLevels.map((x) => x.levelId)
      this.isSubscribed = this.levelIds.map((x) => userLevels.includes(x.levelId))
      this.isSubscribedStartState = this.levelIds.map((x) => userLevels.includes(x.levelId))
    }
  },
  methods: {
    async onUpdate() {
      this.loading = true

      const { data } = await this.$apollo.mutate({
        mutation: UPDATE_MANY_USER_LEVELS,
        variables: {
          data: {
            levelIds: this.isSubscribed
              .map((x, index) => {
                return {
                  levelId: this.levelIds[index].levelId,
                  subscribed: x
                }
              })
              .filter((x, index) => this.isSubscribedStartState[index] !== x.subscribed)
          }
        }
      })

      const userLevels = data.updateManyUserLevels.map((x) => {
        return { levelId: x.levelId }
      })
      this.$store.set('user/user@userLevels', userLevels)
      this.isSubscribedStartState = [...this.isSubscribed]

      this.$buefy.notification.open({
        duration: 5000,
        message: this.$t('subscriptions.success'),
        type: 'is-success'
      })

      this.loading = false
    }
  }
}
